import {
	AnyEntryPropertyEntityType,
	AnyPropertyDefinitionEntityType,
	EntityType,
	Repository,
	PropertyDefinition,
	PropertyDefinitionSelectStringOptionEntry,
	PropertyDefinitionConfig
} from './types';
import {NOTE_REPOSITORY, NOTE_REPOSITORY_TEMPLATE_PROPERTIES} from './systemRecords/note';
import {REFERENCE_REPOSITORY} from './systemRecords/reference';
import {QUERY_REPOSITORY} from './systemRecords/query';
import {CHART_REPOSITORY} from './systemRecords/chart';
import { GRID_REPOSITORY } from './systemRecords/grid';
import { ANCHOR_REPOSITORY } from './systemRecords/anchor';
import { TIMELINE_REPOSITORY } from './systemRecords/timeline';
import {REPOSITORY_REPOSITORY, REPOSITORY_REPOSITORY_TEMPLATE_PROPERTIES} from './systemRecords/repository';
import {
	TEMPLATE_PROPERTY_STRING_REPOSITORY,
	TEMPLATE_PROPERTY_STRING_TEMPLATE_PROPERTIES
} from './systemRecords/propertyDefinitionString';
import {REPOSITORY_ENTRY_REPOSITORY} from './systemRecords/repositoryEntry';
import {
	TEMPLATE_PROPERTY_BOOLEAN_REPOSITORY,
	TEMPLATE_PROPERTY_BOOLEAN_TEMPLATE_PROPERTIES
} from './systemRecords/propertyDefinitionBoolean';
import {
	TEMPLATE_PROPERTY_BELONGS_TO_REPOSITORY,
	TEMPLATE_PROPERTY_BELONGS_TO_TEMPLATE_PROPERTIES
} from './systemRecords/propertyDefinitionBelongsTo';
import {
	TEMPLATE_PROPERTY_HAS_REPOSITORY,
	TEMPLATE_PROPERTY_HAS_TEMPLATE_PROPERTIES
} from './systemRecords/propertyDefinitionHas';
import { 
	TEMPLATE_PROPERTY_DATE_REPOSITORY,
	TEMPLATE_PROPERTY_DATE_TEMPLATE_PROPERTIES
} from './systemRecords/propertyDefinitionDate';
import {
	TEMPLATE_PROPERTY_DATE_TIME_REPOSITORY,
	TEMPLATE_PROPERTY_DATE_TIME_TEMPLATE_PROPERTIES,
} from './systemRecords/propertyDefinitionDateTime';
import {
	TEMPLATE_PROPERTY_NUMBER_REPOSITORY,
	TEMPLATE_PROPERTY_NUMBER_TEMPLATE_PROPERTIES,
} from './systemRecords/propertyDefinitionNumber';
import {
	TEMPLATE_PROPERTY_TEXT_REPOSITORY,
	TEMPLATE_PROPERTY_TEXT_TEMPLATE_PROPERTIES,
} from './systemRecords/propertyDefinitionText';

export const SYSTEM_TEMPLATE_PROPERTIES: PropertyDefinition[] = [
	...NOTE_REPOSITORY_TEMPLATE_PROPERTIES,
	...REPOSITORY_REPOSITORY_TEMPLATE_PROPERTIES,
	...TEMPLATE_PROPERTY_STRING_TEMPLATE_PROPERTIES,
	...TEMPLATE_PROPERTY_BOOLEAN_TEMPLATE_PROPERTIES,
	...TEMPLATE_PROPERTY_BELONGS_TO_TEMPLATE_PROPERTIES,
	...TEMPLATE_PROPERTY_HAS_TEMPLATE_PROPERTIES,
	...TEMPLATE_PROPERTY_DATE_TEMPLATE_PROPERTIES,
	...TEMPLATE_PROPERTY_DATE_TIME_TEMPLATE_PROPERTIES,
	...TEMPLATE_PROPERTY_NUMBER_TEMPLATE_PROPERTIES,
	...TEMPLATE_PROPERTY_TEXT_TEMPLATE_PROPERTIES,
];

/** TODO: I don't think we should carry on trying to fit internal structures into the dynamic data framework  */
export const REPOSITORIES_BY_ENTITY_TYPE: Record<string, PropertyDefinitionConfig> = {
	[EntityType.Note]: NOTE_REPOSITORY,
	[EntityType.Reference]: REFERENCE_REPOSITORY,
	[EntityType.Query]: QUERY_REPOSITORY,
	[EntityType.Chart]: CHART_REPOSITORY,
	[EntityType.Grid]: GRID_REPOSITORY,
	[EntityType.Anchor]: ANCHOR_REPOSITORY,
	[EntityType.Timeline]: TIMELINE_REPOSITORY,
	[EntityType.Repository]: REPOSITORY_REPOSITORY,
	[EntityType.PropertyDefinitionString]: TEMPLATE_PROPERTY_STRING_REPOSITORY,
	[EntityType.PropertyDefinitionText]: TEMPLATE_PROPERTY_TEXT_REPOSITORY,
	[EntityType.PropertyDefinitionBoolean]: TEMPLATE_PROPERTY_BOOLEAN_REPOSITORY,
	[EntityType.PropertyDefinitionBelongsTo]: TEMPLATE_PROPERTY_BELONGS_TO_REPOSITORY,
	[EntityType.PropertyDefinitionHas]: TEMPLATE_PROPERTY_HAS_REPOSITORY,
	[EntityType.RepositoryEntry]: REPOSITORY_ENTRY_REPOSITORY,
	[EntityType.PropertyDefinitionDate]: TEMPLATE_PROPERTY_DATE_REPOSITORY,
	[EntityType.PropertyDefinitionDatetime]: TEMPLATE_PROPERTY_DATE_TIME_REPOSITORY,
	[EntityType.PropertyDefinitionNumber]: TEMPLATE_PROPERTY_NUMBER_REPOSITORY,
};

/** TODO: I don't think we should carry on trying to fit internal structures into the dynamic data framework  */
export const REPOSITORY_ENTRY_ENTITY_TYPES_BY_SYSTEM_REPOSITORY_IDS = {
	[NOTE_REPOSITORY.id]: EntityType.Note,
	[REPOSITORY_REPOSITORY.id]: EntityType.Repository,
	[TEMPLATE_PROPERTY_STRING_REPOSITORY.id]: EntityType.PropertyDefinitionString,
	[TEMPLATE_PROPERTY_BOOLEAN_REPOSITORY.id]: EntityType.PropertyDefinitionBoolean,
	[TEMPLATE_PROPERTY_BELONGS_TO_REPOSITORY.id]: EntityType.PropertyDefinitionBelongsTo,
	[TEMPLATE_PROPERTY_HAS_REPOSITORY.id]: EntityType.PropertyDefinitionHas,
};

export const PROPERTY_DEFINITION_TYPES = [
	EntityType.PropertyDefinitionString,
	EntityType.PropertyDefinitionText,
	EntityType.PropertyDefinitionNumber,
	EntityType.PropertyDefinitionBoolean,
	EntityType.PropertyDefinitionDatetime,
	EntityType.PropertyDefinitionDate,
	EntityType.PropertyDefinitionBelongsTo,
	EntityType.PropertyDefinitionHas,
];

export const ENTRY_PROPERTY_TYPES = [
	EntityType.EntryPropertyString,
	EntityType.EntryPropertyText,
	EntityType.EntryPropertyBoolean,
	EntityType.EntryPropertyBelongsTo,
	EntityType.EntryPropertyDate,
	EntityType.EntryPropertyDatetime,
	EntityType.EntryPropertyNumber,
];

export const PROPERTY_DEFINITION_TYPES_TO_ENTRY_PROPERTY_TYPES: Record<AnyPropertyDefinitionEntityType, AnyEntryPropertyEntityType> = {
	[EntityType.PropertyDefinitionText]: EntityType.EntryPropertyText,
	[EntityType.PropertyDefinitionString]: EntityType.EntryPropertyString,
	[EntityType.PropertyDefinitionBoolean]: EntityType.EntryPropertyBoolean,
	[EntityType.PropertyDefinitionBelongsTo]: EntityType.EntryPropertyBelongsTo,
	[EntityType.PropertyDefinitionDate]: EntityType.EntryPropertyDate,
	[EntityType.PropertyDefinitionDatetime]: EntityType.EntryPropertyDatetime,
	[EntityType.PropertyDefinitionNumber]: EntityType.EntryPropertyNumber,
} as Record<AnyPropertyDefinitionEntityType, AnyEntryPropertyEntityType>;

const getRepositoryAsSelectOption = (repository: Repository): PropertyDefinitionSelectStringOptionEntry => ({
	id: `idRepositorySelectOption${repository.id}`,
	type: EntityType.PropertyDefinitionSelectStringOption,
	parentId: 'SYSTEM',
	label: repository.singular ?? '',
	value: repository.id,
});

export const GENERIC_ENTRY_VIEW_ADD_ENTRY_REPOSITORY_OPTIONS: PropertyDefinitionSelectStringOptionEntry[] = [
	getRepositoryAsSelectOption(NOTE_REPOSITORY as Repository),
	getRepositoryAsSelectOption(REPOSITORY_REPOSITORY as Repository)
];

export const REPOSITORY_TEMPLATE_VIEW_ADD_ENTRY_REPOSITORY_OPTIONS: PropertyDefinitionSelectStringOptionEntry[] = [
	getRepositoryAsSelectOption(TEMPLATE_PROPERTY_STRING_REPOSITORY as Repository),
	getRepositoryAsSelectOption(TEMPLATE_PROPERTY_BOOLEAN_REPOSITORY as Repository),
	getRepositoryAsSelectOption(TEMPLATE_PROPERTY_BELONGS_TO_REPOSITORY as Repository),
	getRepositoryAsSelectOption(TEMPLATE_PROPERTY_HAS_REPOSITORY as Repository),
	getRepositoryAsSelectOption(TEMPLATE_PROPERTY_DATE_REPOSITORY as Repository),
];

export const REPOSITORY_ENTRIES_VIEW_ADD_ENTRY_REPOSITORY_OPTIONS: PropertyDefinitionSelectStringOptionEntry[] = [
	getRepositoryAsSelectOption(REPOSITORY_ENTRY_REPOSITORY as Repository),
];

export const SWAP_TOKEN_URL_PATH = 'auth/swapToken';
/** Dispatched when auth must be cleared (avoids importing authSlice from api.ts). */
export const RESET_AUTH_ACTION_TYPE = 'auth/resetState';
/** Refresh internal JWT this long before `exp`. */
export const TOKEN_REFRESH_LEAD_MS = 5 * 60 * 1000;

/** Viewports this short (e.g. a phone in landscape) get compact, corner-hugging controls. */
export const SHORT_SCREEN_MEDIA_QUERY = '(max-height: 500px)';
